<template lang="pug">
  v-flex
    v-layout.mt-4
      v-text-field(type='number' v-model='search' prepend-icon='fa-search' label='Buscar código' single-line hide-details)
    v-layout.mt-4
        h2 Partidas contables
        v-spacer
        registroPartidas
    v-card.mt-5
      v-data-table.elevation-1( :headers="headers" :items="record" :search='search')
        template( v-slot:item.action="props" )
              v-tooltip(top)
                template(v-slot:activator="{ on }")
                  v-btn( v-on='on' text icon color='secondary' @click='editar(props.item.key)') 
                    v-icon far fa-edit
                span(strong) Editar partida contable
              v-tooltip(top)
                template(v-slot:activator="{ on }")
                  v-btn( v-on='on' text icon color='secondary' @click='borrar(props.item.key)') 
                    v-icon far fa-trash-alt
                span(strong) Eliminar partida contable
              
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { getPeriod } from '@/Helper'
import {fb} from '@/FirebaseConfig'
export default {
  data: ()=>({
    registerDialog: false,
    search: '',
    headers: [
      { text: 'Código',     align: 'center',              value: 'codigo', sortable: false },       
      { text: 'Descripción',    align: 'center',           value: 'descripcion', sortable: false},              
      { text: 'Editar/Eliminar',     align: 'center',          value: 'action', sortable: false},      
    ],
  }),
  
  methods:{
    ...mapActions({
      editar: 'Partidas_Contables/get',
      limpiar: 'Partidas_Contables/clean'
    }),
    borrar(key){
      this.$store.dispatch('Partidas_Contables/clean', key)    
    }
  }, 
  computed:{
    ...mapGetters({
      record: 'Partidas_Contables/record',
    }),
    ...mapState({
      partidas_contables: state => state.PartidasContables
    })
  },  
  components:{
    dataPickerCombobox: ()=>import('../../inventory/components/dataPickerCombobox'),
    registroPartidas: ()=>import('../../contable/componentes/registroPartidasContables')
  }
}
</script>